import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d15d3df"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "模板管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.add,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          style: {"margin-top":"10px"},
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(record.status == 0 ? '禁用' : '正常'), 1))
              : _createCommentVNode("", true),
            (column.key === 'tplOps')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(record.tplOps, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    style: {"margin-right":"10px"}
                  }, _toDisplayString(item.label), 1))
                }), 128))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "操作该数据?",
                    onConfirm: ($event: any) => (_ctx.onStatus(record))
                  }, {
                    default: _withCtx(() => [
                      (record.status==1)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            size: "small",
                            style: {"margin":"5px"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (record.status==0)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            size: "small",
                            style: {"margin":"5px"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "删除该数据?",
                    onConfirm: ($event: any) => (_ctx.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmit('formRef'))),
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          rules: _ctx.rules,
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "模板名称",
              name: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.title,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.title) = $event)),
                  placeholder: "请输入模板名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "选项",
              name: "options"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.options,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.options) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择选项",
                  mode: "multiple"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.xuanxiangList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}